import {Component} from "@angular/core";
import {ViewFooterModel} from "../_models/ViewFooterModel";
import {IT_VIEW_FOOTER_CONTROLLER, IViewFooterController, MK_VIEW_FOOTER} from "../_controllers/IViewFooterController";
import {AbstractView} from "../../../views/AbstractView";

@Component({
  selector: 'link-view-footer',
  templateUrl: './view-footer.view.html',
  styleUrls: ['./view-footer.view.scss']
})
export class ViewFooterView extends AbstractView<IViewFooterController> {

  protected readonly model: ViewFooterModel;

  constructor() {
    super(IT_VIEW_FOOTER_CONTROLLER);

    this.model = this.getController().getModel(MK_VIEW_FOOTER);
  }

  protected actionClicked(actionName: string) {
    this.getController().handle(actionName, {});
  }

  protected flagChanged(flagName: string, flagValue: boolean) {
    this.handle(flagName, {
      value: flagValue,
    });
  }
}
